import {
  ResourceAdvancedFilter,
  ResourceFilterOptionList,
  ResourceFilterSelect,
  type ResourceFilterOption
} from '@/shared/ui/Layout'

import type { PartnersAdvancedFilters } from '../hooks/usePartnersListFilters'

const LABELS = {
  title: 'Filtros',
  category: 'Categoria',
  allOption: 'Todas as categorias',
  clearAll: 'Limpar filtros',
  apply: 'Aplicar'
} as const

type PartnersAdvancedFilterProps = {
  filters: PartnersAdvancedFilters
  emptyDraft: PartnersAdvancedFilters
  options: ResourceFilterOption<string>[]
  hasActiveFilters: boolean
  onApplyDraft: (draft: PartnersAdvancedFilters) => void
  onReset: () => void
  className?: string
}

const hasCategoryValue = (filters: PartnersAdvancedFilters) =>
  Boolean(filters.categoryId)

export const PartnersAdvancedFilter = ({
  filters,
  emptyDraft,
  options,
  hasActiveFilters,
  onApplyDraft,
  onReset,
  className
}: PartnersAdvancedFilterProps) => (
  <ResourceAdvancedFilter
    title={LABELS.title}
    clearLabel={LABELS.clearAll}
    applyLabel={LABELS.apply}
    appliedFilters={filters}
    emptyDraft={emptyDraft}
    hasActiveFilters={hasActiveFilters}
    isDraftActive={hasCategoryValue}
    hidden={options.length <= 1}
    className={className}
    triggerAriaLabel={LABELS.title}
    onReset={onReset}
    onApplyDraft={onApplyDraft}
    renderFields={({ layout, filters: currentFilters, updateFilters }) =>
      layout === 'mobile' ? (
        <ResourceFilterOptionList
          label={LABELS.category}
          emptyLabel={LABELS.allOption}
          options={options}
          value={currentFilters.categoryId}
          onChange={categoryId => updateFilters({ categoryId })}
        />
      ) : (
        <ResourceFilterSelect
          id="partners-filter-category"
          label={LABELS.category}
          emptyLabel={LABELS.allOption}
          options={options}
          value={currentFilters.categoryId}
          onChange={categoryId => updateFilters({ categoryId })}
        />
      )
    }
  />
)

PartnersAdvancedFilter.displayName = 'PartnersAdvancedFilter'
